import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "./AuthProvider";
import { toast } from "sonner";
import api from '../api/NotificationReq';
import date_parser from '../utils/date_parser';

const NotificationContext = createContext(null);

export const NotificationsProvider = ({ children }) => {
    const { isAuthenticated } = useAuth();
    const [notifications, setNotifications] = useState([]);
    const [notificationsNotRead, setNotificationsNotRead] = useState(0);

    useEffect(() => {
        const fetchNotifications = async () => {
            try {
                const response = await api.get('', {withCredentials: true});
                if (response.data.success) {
                    const notificationsWithoutDateParsing = response.data.payload;
                    const notificationsWithDateParsed = notificationsWithoutDateParsing.map((prev) => {
                        const parsedDate = date_parser(prev.created_at);
                        return {...prev, created_at: parsedDate};
                    })
                    setNotifications(notificationsWithDateParsed);
                    const notReadNotifications = response.data.payload.filter(notification => !notification.is_read);
                    setNotificationsNotRead(notReadNotifications.length);
                } else {
                    toast.error('Some undefined error');
                }
            } catch (err) {
                console.log(err.response)
            }
        }
        if (isAuthenticated) {
            fetchNotifications()
        } else {
            setNotifications([]);
            setNotificationsNotRead(0);
        }
        
    }, [isAuthenticated])

    return (
        <NotificationContext.Provider
            value={{
                notifications,
                setNotifications,
                notificationsNotRead,
                setNotificationsNotRead
            }} 
        >
            {children}
        </NotificationContext.Provider>
    )
}

export const useNotifications = () => {
    return useContext(NotificationContext);
}